import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChartService {

  constructor(private ws: PostmethodService) { }
//Top Cards Count
  getCardData(request:any){
    return this.ws.wsPost(request, environment.baseUrl + "/lead/overviewCounts");
  }
//Bar Graph
  getChartData(request:any){
    return this.ws.wsPost(request, environment.baseUrl + "/lead/overviewGraph");
  }
  //Bar Graph
  getChartDataSales(request:any){
    return this.ws.wsPost(request, environment.baseUrl + "/lead/overview-lead-distribution-graph");
  }
//Card Graph
  getPercentageData(request:any){
    return this.ws.wsPost(request, environment.baseUrl + "/lead/overviewPercentages");
  }
  //Donut
  getDonutData(request:any){
    return this.ws.wsPost(request, environment.baseUrl + "/lead/overviewCharts");
  }
}
